// extracted by mini-css-extract-plugin
export default {"name":"item-title__name___TGi7H","nameOriginal":"item-title__nameOriginal___S7DRs","nameLabel":"item-title__nameLabel___dkM5L","label":"item-title__label___hY8Yd"};